import PropTypes from 'prop-types'
import styles from '../publicacionSinDetalle/PublicacionSinDetalle.module.css'

export const SumarProductos = ({
  cantidad,
  setCantidad,
  decrementar,
  incrementar,
  cantDisponible,
  agregarAlCarrito,
  deshabilitarBoton = false
}) => {
  const onChangeCantidad = (value) => {
    const numericValue = Number(value)
    const boundedValue = Number.isNaN(numericValue)
      ? 1
      : Math.max(1, Math.min(numericValue, cantDisponible))
    setCantidad(boundedValue)
  }

  const normalizarCantidad = () => {
    const valueFinal = Math.max(1, Math.min(Number(cantidad || 1), cantDisponible))
    setCantidad(valueFinal)
  }

  return (
    <div>
      {cantDisponible > 0 ? (
        <div className={styles.containerInfo}>
          <div className="input-group" style={{ width: '180px' }}>
            <button
              type="button"
              className="btn border-dark border-end-0 fw-bold"
              onClick={decrementar}
              disabled={cantidad <= 1 || deshabilitarBoton}
            >
              –
            </button>

            <input
              type="number"
              className={`form-control border-dark ${styles.inputCentrado}`}
              style={{ maxWidth: '70px', padding: 0 }}
              value={cantidad}
              min="1"
              max={cantDisponible}
              onChange={(e) => onChangeCantidad(e.target.value)}
              onBlur={normalizarCantidad}
              onClick={(e) => e.stopPropagation()}
              disabled={deshabilitarBoton}
            />
            <button
              type="button"
              className="btn border-dark border-start-0 fw-bold rounded-end"
              onClick={incrementar}
              disabled={cantidad >= cantDisponible || deshabilitarBoton}
            >
              +
            </button>
            {agregarAlCarrito && (
              <div>
                <button
                  type="button"
                  className={`btn btn-primary ${styles.btnAgregar}`}
                  onClick={(e) => agregarAlCarrito(e)}
                  title="Agregar al carrito"
                  disabled={deshabilitarBoton}
                >
                  <i className={`bi bi-cart-plus ${styles.iconoCarrito}`}></i>
                </button>
              </div>
            )}
          </div>
          <span className={styles.cantidadDisponible}>Cantidad disponible: {cantDisponible}</span>
        </div>
      ) : (
        <p className={styles.sinStock}>SIN STOCK</p>
      )}
    </div>
  )
}

SumarProductos.propTypes = {
  cantidad: PropTypes.number.isRequired,
  setCantidad: PropTypes.func.isRequired,
  decrementar: PropTypes.func.isRequired,
  incrementar: PropTypes.func.isRequired,
  cantDisponible: PropTypes.number.isRequired,
  agregarAlCarrito: PropTypes.func.isRequired,
  deshabilitarBoton: PropTypes.bool
}
